import React, { FC } from 'react';
import { Button, ButtonStyles } from '@silverfort/sf-components';

interface TokenActionsProps {
    onSave: () => void;
    onCancel?: () => void;
    saveLabel?: string;
    cancelLabel?: string;
    disabled?: boolean;
    saveDisabled?: boolean;
}

const TokenActions: FC<TokenActionsProps> = ({
    onSave,
    onCancel,
    disabled,
    saveDisabled,
    saveLabel = 'Save',
    cancelLabel = 'Cancel'
}) => {
    return (
        <div className="flex flex-row gap-2 justify-end">
            <Button buttonStyle={ButtonStyles.GhostSolid} text={cancelLabel} onClick={onCancel} disabled={disabled} />
            <Button text={saveLabel} onClick={onSave} disabled={disabled || saveDisabled} />
        </div>
    );
};

export default TokenActions;
